import { TColumnName, TDataset, TRow } from "../types";
import { ID_COLUMN } from "../constants";
import MathUtils from "./MathUtils";
import ColumnUtils from "./ColumnUtils";

class RowUtils {
  static getValue(row: TRow, columnName: TColumnName) {
    return row[columnName];
  }

  static getValueAsNumber(row: TRow, columnName: TColumnName) {
    const value = RowUtils.getValue(row, columnName);
    return MathUtils.isNumberAsString(value) ? Number(value) : 0;
  }

  static getId(row: TRow) {
    return row[ID_COLUMN];
  }

  static getValues(
    rows: TDataset,
    columnNames: TColumnName[]
  ): Array<number[]> {
    const result: Array<number[]> = [];

    const numberOfRows = rows.length;

    for (let i = 0; i < numberOfRows; i++) {
      const row = rows[i];

      columnNames.forEach((columnName, index) => {
        if (!result[index]) {
          result[index] = [];
        }

        const value = RowUtils.getValue(row, columnName);
        if (MathUtils.isNumberAsString(value)) {
          result[index].push(Number(value));
        }
      });
    }

    return result;
  }

  static getColumnNames(row: TRow) {
    return Object.keys(row).filter((key) => key !== "") as TColumnName[];
  }

  static getPointsForMethod(rows: TDataset, method: TColumnName) {
    const x_key = method;
    const { Y: y_key, Z: z_key } = ColumnUtils.getMethodColumnYZNames(method);

    const data = [];
    const size = rows.length;

    for (let i = 0; i < size; i++) {
      data.push(
        [
          RowUtils.getValue(rows[i], x_key),
          RowUtils.getValue(rows[i], y_key),
          RowUtils.getValue(rows[i], z_key),
        ].map((x) => parseFloat(x || "0"))
      );
    }

    return data;
  }
}

export default RowUtils;
